export const l_flex_item_Order = {
  "name": "--pf-v6-l-flex--item--Order",
  "value": "0",
  "var": "var(--pf-v6-l-flex--item--Order)"
};
export default l_flex_item_Order;